import React from 'react'
import { useContent } from '../../services'
import Chefsection from '../Menchefs/Chefsection'
import Quotesection from '../Menchefs/Quotesection'
import Teem from '../Menhome/Teem'
import Bredcrumb from '../Bredcrumb/Main'
import PageSEO from '../SEO/PageSEO'
import Img from '../../assets/images/background/banner-image-5.jpg'

const BREADCRUMB_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://www.huqup380.com/' },
    { '@type': 'ListItem', position: 2, name: 'Our Team', item: 'https://www.huqup380.com/ourchefs' }
  ]
}

function Main() {
  const { data, loading } = useContent('teamContent');

  if (loading || !data) return null;

  const { breadcrumb } = data.chefPage;

  return (
    <>
      <PageSEO
        title="Our Team"
        description="Meet the talented team behind Huq Up - Cafe & Grill in Little Elm, TX — the chefs and staff who bring bold flavors to your table every day."
        canonical="https://www.huqup380.com/ourchefs"
        structuredData={BREADCRUMB_SCHEMA}
      />
      <Bredcrumb subtitle={breadcrumb.subtitle} title={breadcrumb.title} Img={Img} />
      <Chefsection />
      <Quotesection />
      <Teem />
    </>
  )
}

export default Main
